const copFormatter = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });
const qtyFormatter = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 3 });
const dateFormatter = new Intl.DateTimeFormat('es-CO', { dateStyle: 'medium', timeStyle: 'short' });

export function formatCOP(value: string | number): string {
  const n = typeof value === 'string' ? Number(value) : value;
  return `$ ${copFormatter.format(n)}`;
}

export function formatQty(value: string | number): string {
  const n = typeof value === 'string' ? Number(value) : value;
  return qtyFormatter.format(n);
}

export function formatDateTime(value: string | Date): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  return dateFormatter.format(d);
}

export function formatPercent(value: string | number): string {
  const n = typeof value === 'string' ? Number(value) : value;
  return `${qtyFormatter.format(n)} %`;
}
